<app-spinner *ngIf="loadingFlag" class="sq-global-backdrop center-aligned"></app-spinner>
<!-- ////////Pop up/////////////////////////////////////////////// -->
<ng-template #content1 let-modal>
    <div class="modal-header content1_modal">
        <h4 class="modal-title heading_info">INFORMATION</h4>
    </div>
    <div class="modal-body">
        <div>
            <div class="alert_message">{{alertMessage}}</div>
            <div class="cancel-del-align1">
                <div class="cancel-del-align">
                    <div>
                        <button type="button" (click)="modal.dismiss();"
                            class="btn btn-secondary btn_cls">OK</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
<!-- ///////////////////////// -->
<div class=" home_wrapper ">

    <div class="bg_icon">
        <div class="humidity"></div>
        <div class="fan"></div>
        <div class="ultility"></div>
        <div class="bulp"></div>
        <div class="air_volume"></div>
       </div>

    <mat-toolbar color="primary">
        <mat-toolbar-row>
            <div class="nav_header_row">
                <div class="nav_header_col_lft">
                    <div class="logocus"></div>
                    <!-- <div class="verticalLine"></div>
                    <div class="logoTCS"></div> -->
                </div>  
                <div class="nav_header_col_rgt">
                    <div class="logoTCS"></div>
                    <!-- <div class="dropdown">
                        <div class="d-flex align-items-center  dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <img class="mx-3" src="./assets/icons/user.svg" alt="Profile" />
                            <div class="profile_user_name"> user name  &nbsp;  &nbsp; <img src="./assets/icons/dropdown_arrow.svg" alt=""></div>
                        </div>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            <a class="dropdown-item" (click)="onClickLogout()">Sign Out</a>
                        </div>
                    </div>
    
                    <div class="verticalLine"></div>
    
                    <div class="nav_header_icon">
                        <img (click)="onClickLogout()" style="cursor: pointer;" src="./assets/icons/logout1.svg" alt="Signout" />
                    </div> -->

                </div>
            </div>
        </mat-toolbar-row>
    </mat-toolbar>
    
    <div class="home_container">
        <div class="Home_head">{{'HOME.KEY' | translate}}</div>
        <div class="row">
            <div *ngFor="let d of homePageJson" (click)="onClickCard($event,d.link)">
                <div class="home_card d-flex align-items-center flex-column justify-content-center">
                    <img class="" src="{{d.icon}}">
                    <p class="mb-0 card_text">{{d['text']}}</p>
                </div>  
            </div>
        </div>
    </div>

    <div class="logout_btn">
        <button class=" cstm_btn_css d-flex align-items-center" (click)="onClickLogout()"> <img class="mr-2" src="./assets/icons/logout.svg" alt="Profile" /><span>Logout</span></button>
      </div>

   <footer class="footer1">
       <p>Copyright © 2022 | TCS Clever Energy<sup>TM</sup>. All Right Reserved.</p>
  </footer>
</div>